export const CHANGELOG_PAGE_SIZE = 20;
export const CHANGELOG_TYPES = Object.freeze({
  schedules: 'schedules',
  classDescriptions: 'class_descriptions',
  instructors: 'instructors',
});
export const ORDERED_CHANGELOG_TYPES = [
  CHANGELOG_TYPES.schedules,
  CHANGELOG_TYPES.classDescriptions,
  CHANGELOG_TYPES.instructors,
];
export const CHANGELOG_ACTION_TYPES = {
  ACTION_CREATE: 'create',
  ACTION_UPDATE: 'update',
  ACTION_DELETE: 'delete',
};
